export default "__VITE_ASSET__D62Ki8zv__"